import React, { useMemo } from 'react';
import styled from 'styled-components';
import SlideRightDialog from './common/SlideRightDialog';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CLOUDGATE_CONFIG = {
  brandKey: '20251110045520e0empotveUweurJdiu8mrw',
  channelType: 'chat',
  // scenarioId: 'NDE2OA==',
};

const StyledIframeWrapper = styled.div`
  height: 100%;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const Twc = ({ isOpen = true, onClose }) => {
  const navigate = useNavigate();
  const { myInfo } = useSelector(state => state.myInfo);

  // 채팅 URL 생성
  const chatUrl = useMemo(() => {
    const baseUrl = 'https://webchat.thecloudgate.io/webChat';
    const params = new URLSearchParams({
      brandKey: CLOUDGATE_CONFIG.brandKey,
      channelType: CLOUDGATE_CONFIG.channelType,
      // scenarioId: CLOUDGATE_CONFIG.scenarioId,
      hideHeader: 'true',
      buttonOption: {
        showLauncher: false,
      },
    });

    // 고객 정보 추가
    if (myInfo) {
      const { htmInsaPerNm, htmComNm, htmComCd, htmInsaPerEMail } = myInfo;
      const sessionId = sStorage.getItem('sessionId') || 'jan';
      const companyCode = htmComCd || 'jan';

      // 로그인 ID (고객 식별용)
      params.append('loginId', `${companyCode}-${sessionId}`);

      // 커스텀 파라미터 (상담사에게 표시될 고객 정보)
      // ※ 클라우드게이트 관리자 > 브랜드 설정 > 채널 연동 > 웹챗|챗봇 설정에서 파라미터 등록 필요
      if (htmInsaPerNm) params.append('UserName', htmInsaPerNm);
      if (htmComNm) params.append('Company', htmComNm);
      if (htmInsaPerEMail) params.append('UserEmail', htmInsaPerEMail);
    }

    return `${baseUrl}?${params.toString()}`;
  }, [myInfo]);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <SlideRightDialog
      isOpen={isOpen}
      onClose={handleClose}
      title="채팅상담"
      contentStyle={{ padding: '0' }}>
      <StyledIframeWrapper>
        <iframe src={chatUrl} title="클라우드게이트 채팅상담" />
      </StyledIframeWrapper>
    </SlideRightDialog>
  );
};

export default Twc;
